// types
import type { ImageGalleryProps } from './types';

// utils
import { useGroup } from 'utils/hooks/use-group';
import { GroupImageGallery } from './group/group-image-gallery';
import { GddsImageGallery } from './gdds/gdds-image-gallery';

export function ImageGallery(props: Readonly<ImageGalleryProps>) {
  const isGroup = useGroup();

  if (isGroup) {
    return <GroupImageGallery key="group" {...props} />;
  }

  return <GddsImageGallery key="gdds" {...props} />;
}
